/**
 *
 * @type {symbol}
 * @description Injection key for the app platform
 * @example inject(appPlatformInjectionKey)
 * @example provide(appPlatformInjectionKey, 'WEB_APP')
 * @see {@link https://vuejs.org/guide/components/provide-inject#working-with-symbol-keys toggle Composition and Options API to see all examples}
 * or in dedicated files: AppAuth.vue AppLink.vue ..etc
 */

// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ APP PLATFORM KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
export const isWebAppInjectionKey = Symbol('isWebApp')
export const isCrossPlatformAppInjectionKey = Symbol('isCrossPlatformApp')
export const isJiraAppInjectionKey = Symbol('isJiraApp')
export const isAzureAppInjectionKey = Symbol('isAzureApp')
export const appPlatformInjectionKey = Symbol('appPlatform')
export const webAppRefererRouteInjectionKey = Symbol('webAppRefererRoute')
// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ APP PLATFORM KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮

// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ OKR ELEMENTS KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
export const listStateInjectionKey = Symbol('listState')
export const commentFormInjectionKey = Symbol('commentForm')
export const descriptionFieldStateInjectionKey = Symbol('descriptionFieldState')
export const roadmapStateInjectionKey = Symbol('roadmapState')
export const subAppStateInjectionKey = Symbol('subAppState')
export const treeStateInjectionKey = Symbol('treeState')
export const tableStateInjectionKey = Symbol('tableState')
export const bulkAddStateInjectionKey = Symbol('bulkAddState')
export const okrElementFormProgressTableStateInjectionKey = Symbol(
  'okrElementFormProgressTableStateInjectionKey'
)
export const progressViewStateInjectionKey = Symbol('progressViewState')
export const splitViewStateInjectionKey = Symbol('splitViewState')
// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ OKR ELEMENTS KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮

// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ IN APP NOTIFICATIONS KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
export const inAppNotificationsStateInjectionKey = Symbol('inAppNotificationsState')
// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ IN APP NOTIFICATIONS KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮

// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ CUSTOM DASHBOARD KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
export const customDashboardStateInjectionKey = Symbol('customDashboardState')
export const customDashboardModulesStateInjectionKey = Symbol('customDashboardModulesState')
export const currentModuleStateInjectionKey = Symbol('currentModuleState')
// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ CUSTOM DASHBOARD KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮

// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ ONBOARDING AI KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
export const onboardingAiStepContextInjectionKey = Symbol('onboardingAiStepContext')
export const onboardingAiBillingCompleteInjectionKey = Symbol('onboardingAiBillingComplete')
// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ ONBOARDING AI KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮

// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ HOMEPAGE KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
export const homePageStateInjectionKey = Symbol('homePageState')
// ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮ HOMEPAGE KEYS ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮
